export const corporativoIntro =
  "Los principios rectores de Axonia Group definen nuestra cultura corporativa y guían cada operación logística, transporte y distribución que realizamos. Estos pilares fundamentan nuestro compromiso con la excelencia B2B y el cumplimiento normativo exigido por nuestros socios estratégicos.";

export const mision = {
  id: "mision",
  numero: "01",
  titulo: "Misión",
  etiqueta: "Propósito Institucional",
  icono: "ri-focus-3-line",
  descripcion:
    "Proveer soluciones integrales de transporte de carga, distribución y logística con los más altos estándares de seguridad, puntualidad y eficiencia operativa, convirtiéndonos en un socio estratégico clave que impulse la cadena de suministro de nuestros clientes corporativos en la República Dominicana.",
};

export const vision = {
  id: "vision",
  numero: "02",
  titulo: "Visión",
  etiqueta: "Proyección a Futuro",
  icono: "ri-eye-2-line",
  descripcion:
    "Ser la empresa de transporte y logística líder y de referencia en el mercado nacional, reconocida por su excelencia operativa, su sólida infraestructura, la innovación en sus procesos y un compromiso inquebrantable con la seguridad y el desarrollo sostenible, honrando nuestro lema: \"Moving a Better Tomorrow\".",
};

export const valoresCorporativos: {
  id: string;
  titulo: string;
  descripcion: string;
  icono: string;
}[] = [
  {
    id: "val-seguridad",
    titulo: "Seguridad",
    descripcion:
      "La protección de nuestro personal, la carga de nuestros clientes y el cumplimiento riguroso de las normas viales e industriales es el eje central de cada operación.",
    icono: "ri-shield-check-line",
  },
  {
    id: "val-compromiso",
    titulo: "Compromiso y Confiabilidad",
    descripcion:
      "Asumimos cada ruta con total responsabilidad, garantizando entregas a tiempo y respuestas ágiles adaptadas a las exigencias del sector B2B.",
    icono: "ri-hand-heart-line",
  },
  {
    id: "val-integridad",
    titulo: "Integridad y Cumplimiento (Compliance)",
    descripcion:
      "Actuamos con total transparencia, ética y apego estricto a las leyes fiscales, mercantiles y laborales del país.",
    icono: "ri-scales-3-line",
  },
  {
    id: "val-excelencia",
    titulo: "Excelencia y Profesionalismo",
    descripcion:
      "Mantenemos una imagen impecable, una flota moderna y un personal altamente capacitado que refleja el estándar de calidad de las marcas a las que servimos.",
    icono: "ri-award-line",
  },
  {
    id: "val-innovacion",
    titulo: "Innovación y Eficiencia",
    descripcion:
      "Optimizamos constantemente nuestros recursos —como nuestra estación interna de combustible y controles de patio— para ofrecer un servicio logístico superior y competitivo.",
    icono: "ri-lightbulb-flash-line",
  },
];